import { useState } from "react";
import CompanyProfile from "../components/settings/CompanyProfile";
import EmailSettings from "../components/settings/EmailSettings";
import LeadSources from "../components/settings/LeadSources";
import { Building2, Mail, Globe } from "lucide-react";

const tabs = [
  { key: "company", label: "Company Profile", icon: Building2 },
  { key: "email", label: "Email Settings", icon: Mail },
  { key: "sources", label: "Lead Sources", icon: Globe },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("company");

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-1">Manage your CRM configuration</p>
      </div>
      <div className="flex space-x-1 bg-gray-100 rounded-xl p-1 w-fit">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              activeTab === tab.key
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </button>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
        {activeTab === "company" && <CompanyProfile />}
        {activeTab === "email" && <EmailSettings />}
        {activeTab === "sources" && <LeadSources />}
      </div>
    </div>
  );
};

export default Settings;
